<template>
  <span>
    <a @click="printPrice"
       :title="$t('print')"
       v-b-tooltip.hover
       class="tdclickable data-table-action">
      <PrintSvg/><span class="action-button-mob-title">{{ $t('print') }}</span>
    </a>
  </span>
</template>

<script>

import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import JwtService from "@/services/jwt.service"
import { mapState } from "vuex"

export default {
  name: "ServicesDatatableActionsPrice",
  components: {
    PrintSvg,
  },
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      clinic: state => state.auth.clinic,
      rights: state => state.auth.rights,
      branch: state => state.auth.branch,
      superadmin: state => state.auth.superadmin,
    })
  },
  methods: {
    printPrice() {
      let link = JwtService.getPrintPrelink(this.clinic, this.superadmin)
      link = link+'/pricelist?branchId='+this.branch+'&price_id='+this.object.id
      if(this.superadmin) {
        link = link + `&superadmin_clinic_id=${this.clinic.id}`
      }
      window.open(link, '_blank')
    }
  }
}
</script>
